import {
    createFileRoute,
    Outlet,
} from '@tanstack/react-router';

import { queryClient } from '@/App';
import { fetchMemberPermissionQueryOptions } from '@/api/memberPermissionsQueryOptions';
import { memberOwnQueryOptions, memberPortraitQueryOptions } from '@/api/memberQueryOptions';
import { organizationLogoQueryOptions } from '@/api/organizationsQueryOptions';
import { getMember, setLogo, setMember, setOrganization, setPortrait, setRole } from '@/store/auth/authSlice';
import LoginIcon from '@mui/icons-material/Login';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useUnleashContext } from '@unleash/proxy-client-react';
import i18next, { t } from 'i18next';
import { useAuth } from 'react-oidc-context';
import { useDispatch, useSelector } from 'react-redux';
import axiosInstance from '../api/axios';

export const Route = createFileRoute('/_auth')({
    component: AuthLayout,
})

function AuthLayout() {
    // console.log('_auth')

    const auth = useAuth()
    const member = useSelector(getMember)
    const dispatch = useDispatch()
    const updateContext = useUnleashContext();

    // React.useEffect(() => {
    //     // the `return` is important - addAccessTokenExpiring() returns a cleanup function
    //     return auth.events.addAccessTokenExpiring(() => {
    //         // console.log('Access token expiring - silent renew')
    //         auth.signinSilent();
    //     })
    // }, [auth, auth.events, auth.signinSilent]);

    // const storage = import.meta.env.VITE_DEBUG === 'true' ? localStorage : sessionStorage
    const storage = sessionStorage

    switch (auth.activeNavigator) {
        case "signinSilent":
            return <div>Signing you in...</div>;
        case "signoutRedirect":
            return <div>Signing you out...</div>;
    }

    if (auth.isLoading) {
        return <></>;
    }

    if (auth.error) {
        <ListItemButton onClick={() => {
            auth.signinRedirect();
        }
        }>
            <ListItemIcon>
                <LoginIcon />
            </ListItemIcon>
            <ListItemText primary={t('action.login')} />
        </ListItemButton>
    }

    if (auth.isAuthenticated) {
        // console.log('authenticated')
        if (auth.user) {
            axiosInstance.defaults.headers.common["Authorization"] = `Bearer ` + auth.user.access_token;
        }

        const { timeZone } = Intl.DateTimeFormat().resolvedOptions()
        axiosInstance.defaults.headers.common['timeZone'] = timeZone
        // queryClient.fetchQuery(fetchSessionQueryOptions()).then((session) => {
        //   console.log('session: ' + JSON.stringify(session))
        // })
        if (storage.getItem('AccessKey')) {
            console.log('Access Key available - using')
            axiosInstance.defaults.headers.common['AccessKey'] = storage.getItem('AccessKey')
            // console.log('member: ' + JSON.stringify(member))
            if (!member.uuid) {
                // initialize state
                console.log('initialize state from AccessKey')
                queryClient.fetchQuery(fetchMemberPermissionQueryOptions(storage.getItem('AccessKey') || '')).then((permission) => {
                    dispatch(setOrganization(permission.organization))
                    dispatch(setRole(permission.role.name))
                    dispatch(setMember(permission.member))
                    queryClient.fetchQuery(memberPortraitQueryOptions(permission.member.uuid)).then((memberPortrait) => {
                        dispatch(setPortrait(memberPortrait))
                    })
                    queryClient.fetchQuery(organizationLogoQueryOptions(permission.organization.uuid)).then((organizationLogo) => {
                        dispatch(setLogo(organizationLogo))
                    })
                    updateContext({ userId: permission.member.scoutId })
                    if (permission.organization.organizationSystem === 'GILDE') {
                        i18next.changeLanguage('de-AT-PGOE')
                    } else if (permission.organization.organizationSystem === 'PFADFINDER' && (
                        permission.organization.abbreviation === 'SPF'
                        || permission.organization.abbreviation === 'SP-FED'
                        || permission.organization.parent?.abbreviation === 'SPF')) {
                        i18next.changeLanguage('de-IT-SP')
                    } else {
                        i18next.changeLanguage('de-AT-PPOE')
                    }
                })
            }
        } else if (!member.uuid) {
            console.log('initialize state from JWT')
            queryClient.fetchQuery(memberOwnQueryOptions()).then((memberData) => {
                if (memberData.length > 0) {
                    const member = memberData[0]
                    dispatch(setMember(member))
                    updateContext({ userId: member.scoutId })
                }

            })
        }

        return (
            <>
                <div id='authDiv' style={{ minWidth: '100px', minHeight: '100px', height: '100%' }}>
                    <Outlet />
                </div>
            </>
        )
    } else if (auth.isLoading) {
        // console.log('auth loading')
        return <>
        </>

    } else {
        const currentUrl = window.location.href;
        if (!currentUrl.includes('start')) {
            console.log('requestedUrl' + currentUrl);
            storage.setItem('requestedUrl', currentUrl)
        }
        // console.log('not authenicated')
        // storage.removeItem('AccessKey')

        auth.signinRedirect();

        return <></>
        //return <button onClick={() => void auth.signinRedirect()}>Log in</button>;
    }
}